module.exports = __webpack_public_path__ + "static/media/loader.2347b51a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/loader.gif
// module id = 561
// module chunks = 0